import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import ButtonLayout from "../../components/layout/buttonlayout";
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography, Box, } from '@mui/material';
import TextFieldBase from "../../components/text/TextFieldBase";
import LoadingButtonBase from "../../components/button/LoadingButtonBase";
import TextFieldBaseMutiline from "../../components/text/TextFieldBaseMutiline";
import DateCalender from "../../components/date/DateCalender";
import FileUploadPopup from "../../components/popUp/FileUploadPopup";
import ComboCode from "../../components/combo/ComboCode";
import { useState, useEffect } from "react";
import AxiosCommon from "../../components/axios/AxiosCommon";
import AxiosLoading from "../../components/axios/AxiosLoading";
import { useSelector } from "react-redux";
import "../common/css/Table.css";
import dayjs from "dayjs";
import { funcMenuWriteYn} from "../../utils/CommonFunction";

const ElectronicPaymentP = (props) => {
  const axiosCommon = AxiosCommon();
  const reduxProfile = useSelector((state) => state.Profile.data);
  const reduxMenuWriteYn = funcMenuWriteYn(useSelector((state) => state.MenuInfo.data),"ElectronicPaymentS");  
  const [loading, setLoading] = useState(false);

  const [insertValue, setInsertValue] = useState({
    company_cd: reduxProfile?.company_cd,
    shop_cd: reduxProfile?.shop_cd,
    user_cd: reduxProfile?.user_cd,
    electronic_cd: props.electronic_cd ? props.electronic_cd : '',
    electronic_dt: props.electronic_dt ? props.electronic_dt : dayjs(new Date()).format("YYYYMMDD"),    
    electronic_tp: props.electronic_tp ? props.electronic_tp : "",
    electronic_ds: props.electronic_ds ? props.electronic_ds : "",
    remark_work_ds: '',
    image_path_ds: '',
    approval3_db_tp:props.approval3_tp?props.approval3_tp:'1', //3차결재 DB등록된 내용(화명에서 변경시 변경되지 않음. 기준값으로 사용)
    approval1_cd:props.approval1_cd?props.approval1_cd:'',
    approval2_cd:props.approval2_cd?props.approval2_cd:'',
    approval3_cd:props.approval3_cd?props.approval3_cd:'', 
    approval1_db_cd:props.approval1_cd?props.approval1_cd:'',
    approval2_db_cd:props.approval2_cd?props.approval2_cd:'',
    approval3_db_cd:props.approval3_cd?props.approval3_cd:'', 
    approval1_tp:props.approval1_tp?props.approval1_tp:'',
    approval2_tp:props.approval2_tp?props.approval2_tp:'',
    approval3_tp:props.approval3_tp?props.approval3_tp:'',
    approval1_ds:props.approval1_ds?props.approval1_ds:'',
    approval2_ds:props.approval2_ds?props.approval2_ds:'',
    approval3_ds:props.approval3_ds?props.approval3_ds:'',
    work_status_tp: '10',
    work_end_dt: props.work_end_dt ? props.work_end_dt:dayjs(new Date()).format("YYYYMMDD"),
    make_cd:reduxProfile?.user_cd, 
    make_ds:reduxProfile?.user_ds,
    remark_ds: '',
    files: { name: "" },
    image_cd: '',
    my_work:false,
    register_cd:'',
    register_ds:'',
  })

  const [validation, setValidation] = useState({});

  const onChange = (e,codeinfo) => {
    const { value, name,  } = e.target;

    //일자,텍스트필드,브랜드 오류초기화
    if (
      name === "make_ds" ||
      name === "electronic_dt" ||
      name === "electronic_tp" ||
      name === "title_ds" ||
      name === "approval1_cd" ||
      name === "approval2_cd" ||
      name === "approval3_cd" ||
      name === "approval1_tp" ||
      name === "approval2_tp" ||
      name === "approval3_tp"
    ){
      setValidation({ ...validation, [name]: "" });
    }
    

    // //결재라인 진행상태
    // if(
    //   name === "approval1_tp" ||
    //   name === "approval2_tp" ||
    //   name === "approval3_tp"
    //  ) {
    //   if(value ==='1'){
    //     alert("진행상태를 확인 해주세요.\n신청 으로 변경 할 수 없습니다.");
    //     // return false;
    //   }
    // }
    
    if (name === "image_path_ds") {
      setInsertValue({
        ...insertValue,
        [e.target.name]: e.target.files[0].name,
        "files": e.target.files[0],
      });
    } else if (name === "my_work" ){   
      setInsertValue({
        ...insertValue,
        manager_cd: !insertValue["my_work"]?reduxProfile?.user_cd:'',
        manager_hpno_ds: !insertValue["my_work"]?reduxProfile?.hpno1.concat(reduxProfile?.hpno2).concat(reduxProfile?.hpno3):'',
        my_work:!insertValue["my_work"],
        // my_work:true,
      });
    } else if (name === "customer_nm" ){  
      setInsertValue({
        ...insertValue,
        [name]: value,
        "customer_cd": '',
      }); 
    }else {
      setInsertValue({
        ...insertValue,
        [name]: value,
      })
    }    
    // //기안구분
    // if (name === "electronic_tp" ){         
    //   if(value ==='11'){
    //     //이월
    //     setVisible({...visible,work_status_tp: true, work_end_dt: false,})
    //   } else if(value ==='12'){
    //     //완료
    //     setVisible({...visible,work_status_tp: false, work_end_dt: true,})        
    //   }else{
    //     setVisible({...visible,work_status_tp: false, work_end_dt: false,})
    //   }
    // }    
  };

  const validationFunc = () => {
    //필수값 체크시 useState값은 비동기로 처리되어 오류를 배열로 만든 후 한번에 넣어야됨
    let validateValue = {};
    
    if (insertValue["make_cd"] !== insertValue["user_cd"]) {
      alert("기안자를 확인 하세요.\n기안자만 등록 할 수 있습니다.\n\n결재자는 결재를 진행 하시기 바랍니다.");
      return false;
    }

    if (!insertValue["make_ds"]) {
      validateValue = {
        ...validateValue,
        make_ds: "기안자를 선택하세요.",
      };
    }
    if (!insertValue["electronic_tp"]) {
      validateValue = {
        ...validateValue,
        electronic_tp: "기안구분을 선택하세요.",
      };
    }
    if (!insertValue["title_ds"]) {
      validateValue = {
        ...validateValue,
        title_ds: "제목을 입력하세요.",
      };
    }
    // if (!insertValue["approval1_cd"]) {
    //   validateValue = {
    //     ...validateValue,
    //     approval1_cd: "승인자를 선택하세요.",
    //   };
    // }
    // if (!insertValue["approval2_cd"]) {
    //   validateValue = {
    //     ...validateValue,
    //     approval2_cd: "승인자를 선택하세요.",
    //   };
    // }
    if (!insertValue["approval3_cd"]) {
      validateValue = {
        ...validateValue,
        approval3_cd: "승인자를 선택하세요.",
      };
    }

        
    if (!!insertValue["electronic_cd"]) {
      if (insertValue["approval1_tp"] !=='' && insertValue["approval1_tp"] !== null ) {
        alert("결재 진행중이거나 완료된 기안서 입니니다.\n등록(수정) 할 수 없습니다.");
        return false;
      }
      if (insertValue["approval2_tp"] !=='' && insertValue["approval2_tp"] !== null ) {
        alert("결재 진행중이거나 완료된 기안서 입니니다.\n등록(수정) 할 수 없습니다.");
        return false;
      }
      if (insertValue["approval3_tp"] !=='' && insertValue["approval3_tp"] !== null ) {
        alert("결재 진행중이거나 완료된 기안서 입니니다.\n등록(수정) 할 수 없습니다.");
        return false;
      }
    }

    /**일자형식 체크 */
    if (
      insertValue["approval_dt"] === "" ||
      insertValue["approval_dt"] === "Invalid Date"
    ) {
      validateValue = {
        ...validateValue,
        work_end_dt: "일자형식이 잘못되었습니다.",
      };
    }

    //텍스트필드 체크
    if (Object.keys(validateValue).length === 0) {
      return true;
    } else {
      setValidation(validateValue);
      return false;
    }
  };

  const funcSave = async () => {
    if (!validationFunc()) return;

    // 중복 검사
    const rawValues = [insertValue["approval1_cd"], insertValue["approval2_cd"], insertValue["approval3_cd"]];

    // 1. 공백 제거 후 유효한 값만 필터링
    const values = rawValues
      .map(v => v?.trim())          // 공백 제거
      .filter(v => v);              // null, undefined, '', '  ' 제거

    // 2. 고유값으로 Set 생성
    const uniqueValues = new Set(values);

    // 3. 유효한 값이 2개 이상이고, 중복이 있다면 경고
    if (uniqueValues.size !== values.length && values.length >= 2) {
      alert("결재자는 중복될 수 없습니다. 서로 다른 결재자를 선택해주세요.");
      return;
    }

    if (loading) return;
    setLoading(true);

    let url = "/community/electronicp/insert";
    
    try {
      const response = await axiosCommon.post(url, insertValue);
      if (response?.data?.code === 200) {
        setInsertValue({ ...insertValue, electronic_cd: response.data.data.electronic_cd });
        //이미지 저장
        const formData = new FormData();
        formData.append("electroinc", insertValue.files);
        let jsonData = JSON.stringify({ ...insertValue, bill_no: response.data.data.electronic_cd });
        formData.append("jsonData", jsonData);
        for (let key of formData.keys()) {
          console.log(key, ":", formData.get(key));
        }
        const response2 = await axiosCommon.post("common/file-upload/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        if (response2?.data?.code === 200) {
          alert("기안을(등록/수정) 했습니다.");
          props.onClick('save');
        }

      }
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  };
  

  const validationFuncUpdate = (buttonId) => {
    
    if ('first' === buttonId){
      //결재 1
      if (insertValue["approval1_cd"] !==insertValue["user_cd"]) {
        alert("승인자를 확인 하세요.");
        return false;
      }
      if(insertValue["approval1_tp"] ==='') {
        alert("진행상태를 확인 하세요.");
        return false;
      }
      if(insertValue["approval3_tp"] !=='') {
        alert("3차 진행상태를 확인 하세요.\n결재 할 수 없습니다.");
        return false;
      }
    }else if ('second' === buttonId){
      //결재 2
      if (insertValue["approval2_cd"] !==insertValue["user_cd"]) {
        alert("승인자를 확인 하세요.");
        return false;
      }
      if(insertValue["approval2_tp"] ==='') {
        alert("진행상태를 확인 하세요.");
        return false;
      }
      if(insertValue["approval1_tp"] !=='4') {
        alert("결재라인1 진행상태를 확인 하세요.\n결재라인1 승인 처리후 결재 할 수 있습니다.");
        return false;
      }
      if(insertValue["approval3_tp"] !=='') {
        alert("3차 진행상태를 확인 하세요.\n결재 할 수 없습니다.");
        return false;
      }
    }else if ('third' === buttonId){
      //결재3
      if (insertValue["approval3_cd"] !==insertValue["user_cd"]) {
        alert("승인자를 확인 하세요.");
        return false;
      }   
      if(insertValue["approval3_tp"] ==='') {
        alert("진행상태를 확인 하세요.");
        return false;
      }
      
      if(insertValue["approval1_cd"] !=='') {
        if(insertValue["approval1_tp"] !=='4') {
          alert("결재라인1 진행상태를 확인 하세요.\n결재라인1 승인 처리후 결재 할 수 있습니다.");
          return false;
        }
      }
      if(insertValue["approval2_cd"] !=='') {
        if(insertValue["approval2_tp"] !=='4') {
          alert("결재라인2 진행상태를 확인 하세요.\n결재라인2 승인 처리후 결재 할 수 있습니다.");
          return false;
        }
      }
    }else{
      alert("결재 실패 했습니다.\n재시도 하세요.");
      return false;
    }
    return true;
    
  };

  const funcUpadate = async (e) => {
    const buttonId = e.currentTarget.name;
    if (!validationFuncUpdate(buttonId)) return;
    if (loading) return;
    setLoading(true);

    let url = ""
    if (buttonId==='first'){
      url="/community/electronicp/update_first";
    }else if(buttonId==='second'){
      url="/community/electronicp/update_second";
    }else if(buttonId==='third'){
      url="/community/electronicp/update_third";
    }

    try {
      const response = await axiosCommon.post(url, insertValue);
      if (response?.data?.code === 200) {
        setInsertValue({ ...insertValue, electronic_cd: response.data.data.electronic_cd });
        //이미지 저장
        const formData = new FormData();
        formData.append("electroinc", insertValue.files);
        let jsonData = JSON.stringify({ ...insertValue, bill_no: response.data.data.electronic_cd });
        formData.append("jsonData", jsonData);
        for (let key of formData.keys()) {
          console.log(key, ":", formData.get(key));
        }
        const response2 = await axiosCommon.post("common/file-upload/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        if (response2?.data?.code === 200) {
          alert("결재 했습니다.");
          props.onClick('save');
        }          
      }
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  };

  const funcSearch = async () => {
    let paramRepo = {
      params: {
        company_cd: insertValue["company_cd"],
        user_cd: insertValue["user_cd"],
        shop_cd: insertValue["shop_cd"],
        electronic_cd: insertValue["electronic_cd"],
        electronic_dt: insertValue["electronic_dt"],
      },
    };
    if (loading) return;
    setLoading(true);
    try {
      await axiosCommon
        .get("/community/electronicp/select", paramRepo)
        .then((response) => {
          if (response.data?.code === 200) {
            // setInsertValue(response.data.data[0]);            
            let data = response.data.data[0];
            setInsertValue(
              {
                ...insertValue,                
                electronic_cd: data.electronic_cd,
                electronic_dt: data.electronic_dt,
                title_ds: data.title_ds,
                make_cd: data.make_cd,
                make_ds: data.make_ds,
                electronic_tp: data.electronic_tp,
                electronic_nm: data.electronic_nm,
                electronic_ds: data.electronic_ds,

                approval1_cd: data.approval1_cd,
                approval2_cd: data.approval2_cd,
                approval3_cd: data.approval3_cd,

                approval1_tp: data.approval1_tp,
                approval2_tp: data.approval2_tp,
                approval3_tp: data.approval3_tp,
                
                approval1_tp_r: data.approval1_tp,
                approval2_tp_r: data.approval2_tp,
                approval3_tp_r: data.approval3_tp,

                approval1_ds: data.approval1_ds,
                approval2_ds: data.approval2_ds,
                approval3_ds: data.approval3_ds,

                approval1_dt: data.approval1_dt,
                approval2_dt: data.approval2_dt,
                approval3_dt: data.approval3_dt,

                approval1_dm: data.approval1_dm,
                approval2_dm: data.approval2_dm,
                approval3_dm: data.approval3_dm,

                image_cd: data.image_cd,
                image_path_ds: data.image_path_ds,
                url_ds:data.url_ds,
                files: { name: "" },
                
                register_dm:data.register_dm,
              }
            );
          }
        });
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  };
  
    
  const funcDelete = async () => {
    if (!insertValue["electronic_cd"]){
      alert("신규 등록 입니다. 삭제 할 수 없습니다.");
      return;
    };
    

    if (insertValue["approval3_cd"] !== insertValue["user_cd"]     ){
      if (insertValue["approval1_tp"]!==''){
        alert("결재 진행중 기안서 입니다. 삭제 할 수 없습니다.");
        return;
      }    
      if (insertValue["approval2_tp"]!==''){
        alert("결재 진행중 기안서 입니다. 삭제 할 수 없습니다.");
        return;
      };
      if (insertValue["approval3_tp"]!==''){
        alert("결재 진행중(완료) 기안서 입니다. 삭제 할 수 없습니다.");
        return;
      };
    }

    if (
      insertValue["approval1_cd"] === insertValue["user_cd"] 
    ){
      alert("1차 승인자는 삭제 할 수 없습니다.");
      return;
    }
    if (
      insertValue["approval2_cd"] === insertValue["user_cd"] 
    ){
      alert("2차 승인자는 삭제 할 수 없습니다.");
      return;
    }

    let paramRepo = {
      params: {
        company_cd:insertValue["company_cd"], 
        shop_cd:insertValue["shop_cd"], 
        user_cd:insertValue["user_cd"],  
        electronic_cd:insertValue["electronic_cd"]
      },
    };

    if (window.confirm("삭제 하시겠습니까?")) {      
    } else {
      return;
    }

    if (loading) return;
    setLoading(true);
    try {
      axiosCommon
        .post("/community/electronicp/delete", paramRepo)
        .then((response) => {
          if (response.data?.code === 200) {
            // alert("기안서를 삭제했습니다.");
            // funcSearch();
            props.onClick('save');
          }
        });
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  };

  const [visible, setVisible] = useState({
    remark_work_ds: false,
    next_cd:false,
    register_ds:false,
    count_rent_qt:false,
    business_tp:false,
    work_end_dt:false
  })

  useEffect(() => {
    if (!props.electronic_cd) return;
    funcSearch();
    setVisible({...visible,  
      remark_work_ds: true, 
      register_ds:true, 
      count_rent_qt:true, 
      work_status_tp:props.work_status_tp==='11'?true:false ,
      business_tp:props.business_tp==='19'?true:false ,
      work_end_dt:props.work_status_tp==='12'?true:false ,
    })
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ pl: '10px', pr: '10px', pb: '10px' }}>

      {loading && <AxiosLoading />}

      <Paper elevation={2} >
      
      <ButtonLayout
        MenuName='결재등록'
      >
        <Box sx={{ borderBottom:0, borderColor: "divider", display: "flex", justifyContent:'flex-end' ,alignItems: "center" }}>   
          {reduxMenuWriteYn &&  
          <LoadingButtonBase
            label="등록"
            onClick={funcSave}
            loading={loading}
            variant="contained"
            name="BUTTON_SAVE"
          />}
          {reduxMenuWriteYn && 
          <LoadingButtonBase
            label="삭제"
            onClick={funcDelete}
            loading={loading}
            variant="contained"
            name="BUTTON_SAVE"
          />}
          <LoadingButtonBase
            label="종료"
            onClick={props.onClick}
            loading={loading}
            variant="contained"
            name="BUTTON_CLOSE"
          />
        </Box>
      </ButtonLayout>
        <TableContainer sx={{ width: '100%', minWidth: '250px', }}>
        
          <Table sx={{ minWidth: 100 }} aria-label="a dense table" >
            <TableBody>
              <TableRow hover sx={{ paddingTop: '5px', paddingBottom: '2px' }}  >
                <TableCell sx={{ width: '180px', borderBottomColor: 'white' }} className='tablecell_base'  >
                  <Typography sx={{ textAlign: 'right', }} component="div"  >
                    기안서
                  </Typography>
                </TableCell>
                <TableCell sx={{width: '170px', pr:'0px', paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>                  
                  <ComboCode
                    required={false}
                    multiple={false}
                    readOnly={true}
                    // disabled={true}                    
                    placeholder="기안자"
                    comboText="기안자"
                    codetype="tb_user"
                    name={"make_cd"} //
                    onChange={onChange} //
                    value={insertValue["make_cd"]} //
                    validation={validation["make_cd"]} //
                  /> 
                </TableCell>
                <TableCell sx={{ width: '170px', paddingTop: '5px', pl:'0px',  paddingBottom: '2px', borderBottomColor: 'white' }}>    
                  
                  <DateCalender
                    required={false} //필수사항 default : flase
                    readOnly={true}
                    // disabled={true}
                    label="기안일자" //label text
                    name={"electronic_dt"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["electronic_dt"]} //화면의표시값
                    validation={validation["electronic_dt"]} //값 체크후 오류시 해당 오류메세지 등록
                    //width={222.67}      //컨퍼넌트넓이 default : 222.67
                  />
                </TableCell>
                <TableCell sx={{  paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>     
                </TableCell>
              </TableRow>
              <TableRow hover sx={{ paddingTop: '5px', paddingBottom: '2px' }}  >
                <TableCell sx={{ width: '180px', borderBottomColor: 'white' }} className='tablecell_base'         >
                  <Typography sx={{ textAlign: 'right' }} component="div"  >
                    기안구분
                  </Typography>
                </TableCell>
                <TableCell sx={{ paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>   
                  < ComboCode
                    required={true}
                    multiple={false}
                    // readOnly={insertValue["electronic_tp"]==='1'||insertValue["electronic_tp"]===''?false:true}
                    // readOnly={!insertValue["electronic_cd"]||insertValue["approval3_db_tp"]==='1'?false:true}         
                    placeholder="기안구분"
                    comboText="기안구분"
                    codetype="C51"
                    codeName="선택"
                    name={"electronic_tp"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["electronic_tp"]} //화면의표시값
                    validation={validation["electronic_tp"]} //                    
                  />
                </TableCell> 
                <TableCell sx={{  paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>                         
                  
                </TableCell>
                <TableCell sx={{  paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>        
                  
                </TableCell>
                <TableCell sx={{  paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>    

                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        
        
        <TableContainer sx={{ width: '100%', minWidth: '250px', }}>
          <Table sx={{ minWidth: 100 }} aria-label="a dense table" >
            <TableBody>
              <TableRow hover sx={{ paddingTop: '5px', paddingBottom: '2px' }}   >
                <TableCell sx={{ width: '180px', borderBottomColor: 'white' }} className='tablecell_base' >
                  <Typography sx={{ textAlign: 'right' }} component="div"  >
                    제목
                  </Typography>
                </TableCell >
                <TableCell sx={{ paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>
                  <TextFieldBase
                    required={true}
                    // readOnly={!insertValue["electronic_cd"]||insertValue["approval3_db_tp"]==='1'?false:true}
                    // disabled={true}
                    label="제목"
                    placeholder=""
                    name={"title_ds"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["title_ds"]} //화면의표시값
                    validation={validation["title_ds"]} //값 체크후 오류시 해당 오류메세지 등록
                    width="97%"
                  />
                </TableCell>
              </TableRow>

              <TableRow hover sx={{ paddingTop: '5px', paddingBottom: '2px' }}   >
                <TableCell sx={{ width: '180px', borderBottomColor: 'white' }} className='tablecell_base' >
                  <Typography sx={{ textAlign: 'right' }} component="div"   >
                    기안내용
                  </Typography>
                </TableCell >
                <TableCell sx={{ paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'white' }}>
                  <TextFieldBaseMutiline
                    required={true}
                    // readOnly={insertValue["electronic_tp"]==='1'||insertValue["electronic_tp"]===''?false:true}   
                    // readOnly={!insertValue["electronic_cd"]||insertValue["approval3_db_tp"]==='1'?false:true}             
                    // disabled={!!props.electronic_tp}
                    multiline={true}
                    placeholder="기안내용"
                    name={"electronic_ds"} //바인딩변수  
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["electronic_ds"]} //화면의표시값
                    width="97%" //컨퍼넌트넓이 default : 222.67
                    rows={visible["electronic_ds"] ?3:3}
                  />
                </TableCell>
              </TableRow>

              <TableRow hover sx={{ paddingTop: '3px', paddingBottom: '0px' }}   >
                <TableCell sx={{ width: '180px', borderBottomColor: 'grey' }} className='tablecell_base' >
                  <Typography sx={{ textAlign: 'right' }} component="div"  >
                    첨부파일
                  </Typography>
                </TableCell >
                <TableCell sx={{ paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'grey' }}>                   
                  <FileUploadPopup
                    //label={"파일업로드"}
                    placeholder={"파일경로"}
                    width={300}
                    name="image_path_ds" //바인딩변수
                    value={insertValue["image_path_ds"]}
                    onChange={onChange} //바인딩 변수 변경 func
                    url_ds={insertValue["url_ds"]}
                    //validation={validation["image_path_ds"]} //값 체크후 오류시 해당 오류메세지 등록
                  />
                </TableCell>
              </TableRow>
              
              <TableRow hover sx={{ paddingTop: '3px', paddingBottom: '2px' }}   >
                <TableCell sx={{ width: '180px', borderBottomColor: 'grey' }} className='tablecell_base' >
                  <Typography sx={{ textAlign: 'right' }} component="div"  >
                    1차 결재라인
                  </Typography>
                </TableCell >
                <TableCell sx={{ paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'grey' }}>
                  <ComboCode
                    required={false}
                    multiple={false}
                    // readOnly={!insertValue["electronic_cd"]?false:true}     
                    placeholder="승인자"
                    comboText="승인자"
                    codetype="tb_user"
                    codeName="선택"
                    name={"approval1_cd"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval1_cd"]} //화면의표시값
                    validation={validation["approval1_cd"]} //
                    width="140px" //컨퍼넌트넓이 
                  />
                  {insertValue["electronic_cd"] &&
                  <ComboCode
                    required={true}
                    multiple={false}
                    readOnly={!insertValue["approval1_tp_r"]?false:true} 
                    placeholder="진행상태"
                    comboText="진행상태"
                    codetype="C52"
                    codeName="선택"
                    name={"approval1_tp"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval1_tp"]} //화면의표시값
                    validation={validation["approval1_tp"]} //
                    width="100px"
                  />}
                  {insertValue["electronic_cd"] &&
                  <TextFieldBase
                    required={false}
                    readOnly={false}
                    // disabled={true}
                    label="결재내용"
                    placeholder=""
                    name={"approval1_ds"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval1_ds"]} //화면의표시값
                    width="530px"
                  />}
                  {insertValue["electronic_cd"] &&
                  <LoadingButtonBase
                    id='first'
                    label="결재"
                    onClick={(e) => funcUpadate(e)}              
                    top='7px'
                    variant="contained"
                    name="first"
                  />}
                </TableCell>
              </TableRow>
              
              <TableRow hover sx={{ paddingTop: '5px', paddingBottom: '2px' }}   >
                <TableCell sx={{ width: '180px', borderBottomColor: 'grey' }} className='tablecell_base' >
                  <Typography sx={{ textAlign: 'right' }} component="div"  >
                    2차 결재라인
                  </Typography>
                </TableCell >
                <TableCell sx={{ paddingTop: '5px', paddingBottom: '2px', borderBottomColor: 'grey' }}>
                  <ComboCode
                    required={false}
                    multiple={false}
                    placeholder="승인자"
                    comboText="승인자"
                    codetype="tb_user"
                    codeName="선택"
                    name={"approval2_cd"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval2_cd"]} //화면의표시값
                    // validation={validation["approval2_cd"]} //
                    width="140px" //컨퍼넌트넓이 
                  />
                  {insertValue["electronic_cd"] &&
                  <ComboCode
                    required={true}
                    multiple={false}
                    // readOnly={!insertValue["approval2_tp"]?false:true}   
                    readOnly={!insertValue["approval2_tp_r"]?false:true}    
                    placeholder="진행상태"
                    comboText="진행상태"
                    codetype="C52"
                    codeName="선택"
                    name={"approval2_tp"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval2_tp"]} //화면의표시값
                    validation={validation["approval2_tp"]} //
                    width="100px"
                  />}
                  {insertValue["electronic_cd"] &&
                  <TextFieldBase
                    required={false}
                    readOnly={false}
                    // disabled={true}
                    label="결재내용"
                    placeholder=""
                    name={"approval2_ds"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval2_ds"]} //화면의표시값
                    width="530px"
                  />}
                  {insertValue["electronic_cd"] &&
                  <LoadingButtonBase
                    id='second'
                    label="결재"
                    onClick={(e) => funcUpadate(e)}
                    loading={loading}               
                    top='7px'
                    variant="contained"
                    name="second"
                  />}
                </TableCell>
              </TableRow>

              <TableRow hover sx={{ paddingTop: '2px', paddingBottom: '0px' }}   >
                <TableCell sx={{ width: '180px', borderBottomColor: 'grey' }} className='tablecell_base' >
                  <Typography sx={{ textAlign: 'right' }} component="div"  >
                    3차 결재라인
                  </Typography>
                </TableCell >
                <TableCell sx={{ paddingTop: '2px', paddingBottom: '0px', borderBottomColor: 'grey' }}>
                  <ComboCode
                    required={true}
                    multiple={false}
                    readOnly={!insertValue["electronic_cd"]?false:true}         
                    placeholder="승인자"
                    comboText="승인자"
                    codetype="tb_user"
                    codeName="선택"
                    name={"approval3_cd"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval3_cd"]} //화면의표시값
                    validation={validation["approval3_cd"]} //
                    width="140px" //컨퍼넌트넓이 
                  />
                  {insertValue["electronic_cd"] &&
                  <ComboCode
                    required={true}
                    multiple={false}
                    readOnly={!insertValue["approval3_tp_r"]?false:true} 
                    placeholder="진행상태"
                    comboText="진행상태"
                    codetype="C52"
                    codeName="선택"
                    name={"approval3_tp"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval3_tp"]} //화면의표시값
                    validation={validation["approval3_tp"]} //
                    width="100px"
                  />}
                  {insertValue["electronic_cd"] &&
                  <TextFieldBase
                    required={false}
                    readOnly={false}
                    // disabled={true}
                    label="결재내용"
                    placeholder=""
                    name={"approval3_ds"} //바인딩변수
                    onChange={onChange} //바인딩 변수 변경 func
                    value={insertValue["approval3_ds"]} //화면의표시값
                    width="530px"
                  />}                  
                  {insertValue["electronic_cd"] &&
                  <LoadingButtonBase
                    id='third'
                    label="결재"
                    onClick={(e) => funcUpadate(e)}
                    top='7px'
                    variant="contained"
                    name="third"
                  />}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        
        
      </Paper>               

    </Box>
  );
}

export default React.memo(ElectronicPaymentP);